import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@classes/extends';
import { HistoData, HistoGalaComponent, HistoGalaComponentData } from '@composants/histo-gala/histo-gala.component';
import { FicheclientService as FicheClientService, GroupeTech, Groupes } from '@estel-numerique/galaclick-api';
import { DateHelper, ValidatorDateService, ValidatorPatternService } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { FicheClientTechniquesComponent, FicheClientTechniquesComponentData } from './ficheclient-techniques/ficheclient-techniques.component';
import { InputGala } from '../../../composants/inputs/input.component';
import { SearchButton, AddButton } from '../../../composants/composants';
import { ButtonGalaDeleteComponent } from '../../../composants/buttons/btn-gala-delete/btn-gala-delete.component';


@Component({
    selector: 'client-groupes',
    providers: [],
    templateUrl: 'ficheclient-groupes.component.html',
    imports: [InputGala, SearchButton, AddButton, ButtonGalaDeleteComponent]
})
export class FicheClientGroupesComponent extends BaseComponent implements OnInit {
    public validDate = inject(ValidatorDateService);
    public validPattern = inject(ValidatorPatternService);
    private formBuilder = inject(UntypedFormBuilder);
    private wsFicheClient = inject(FicheClientService);
    private dialog = inject(MatDialog);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT;

    @Input() public titre: string;

    public groupesTech: Groupes;
    public idClient: number;
    public formAjout: UntypedFormGroup;
    public listeHistoGroupes: GroupeTech[] = [];
    protected lgTrad: Record<string, string>;

    constructor() {
        super();
        this.formAjout = this.formBuilder.group({
            TYPESERV: [null, [Validators.required]]
        });
        this.lgTrad = {
            GRPTECHNIQUES: this.translate.instant("APPFICHECLIENT.COLTAB.GRPTECHNIQUES"),
            ENGAGEMENTS: this.translate.instant("APPFICHECLIENT.COLTAB.ENGAGEMENTS"),
            HISTOGRP: this.translate.instant("APPFICHECLIENT.HISTOGRP"),
            NOM: this.translate.instant("NOM"),
            RET: this.translate.instant("RET"),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
        };
    }


    // =========================================================================
    // CHARGEMENT CONTEXTE
    // =========================================================================

    ngOnInit(): void {
        super.ngOnInit();
    }

    initialiseGroupes(groupesTech: Groupes, idClient: number) {
        this.groupesTech = groupesTech;
        this.idClient = idClient;
    }

    public getMulcln() {
        return this.groupesTech.MULCLN + ' Kg au ' + ((this.groupesTech.DATECTRL != null) ?
            this.groupesTech.DATECTRL : DateHelper.getDateJourISO());
    }

    public openGrpTechniques() {
        this.openModalTech({ idClient: this.idClient, listeGroupesTech: this.groupesTech });
    }

    public deleteGrpTechnique(grp: GroupeTech) {
        this.openModalTech({ idClient: this.idClient, listeGroupesTech: this.groupesTech, groupe: grp });
    }
    private openModalTech(oData: FicheClientTechniquesComponentData) {
        const dialogTech = this.dialog.open(FicheClientTechniquesComponent, { data: oData });
        dialogTech.componentInstance.saved.subscribe((groupe) => {
            this.savedGroupe(groupe);
        });
    }

    public async askFavorite(grp: GroupeTech) {
        if (await this.util.confirmation(this.translate.instant('APPFICHECLIENT.ASKMODIFFAV'), this.translate.instant('MODIFDONE'))) {
            await this.makeFavorite(grp);
        }
    }

    public async makeFavorite(grp: GroupeTech) {
        try {
            this.util.showLoader();
            await lastValueFrom(this.wsFicheClient.putGroupeFavori(this.idClient, grp));
            this.changeFav(grp);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public changeFav(groupe: GroupeTech) {
        // On remove l'ancien favori
        const grp: GroupeTech = this.groupesTech.GROUPESTECH.find((g: GroupeTech) => {
            return g.FAVORI == 1;
        });
        if (grp) {
            grp.FAVORI = 0;
        }

        // On met le nouveau favori
        groupe.FAVORI = 1;
    }

    public savedGroupe(groupe: GroupeTech) {
        const index = this.groupesTech.GROUPESTECH.findIndex((grp: GroupeTech) => {
            return groupe.IDGRPCLIENT == grp.IDGRPCLIENT;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(groupe.DDEBUT, groupe.DFIN, false)) {
                this.groupesTech.GROUPESTECH.splice(index, 1);
            } else {
                this.groupesTech.GROUPESTECH.splice(index, 1, groupe);
            }
        } else {
            this.groupesTech.GROUPESTECH.push(groupe);
        }
    }

    public async openHistoGrpTechniques() {
        try {
            this.util.showLoader();
            this.listeHistoGroupes = await lastValueFrom(this.wsFicheClient.getGroupesHisto(this.idClient));
            const oData: HistoGalaComponentData = {
                titre: this.translate.instant("APPFICHECLIENT.HISTOGRP"),
                liste: this.listeHistoGroupes.map((grp) => {
                    return {
                        nom: grp.RFGROUPE.GROUPE,
                        debut: grp.DDEBUT,
                        fin: grp.DFIN,
                    } as HistoData;
                })
            };
            this.dialog.open(HistoGalaComponent, { data: oData });
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }
}
